<span *ngIf="isListloading" class="justify-content-center">
  <app-loading [displayeMessage]="true"></app-loading>
</span>
<div *ngIf="reviewersStatusperTask.length>0">
  <table class="table-new-design" style="border-collapse:collapse !important; ">
    <thead>
      <tr>
        <th>IsApprover?</th>
        <th>Reviewer(s)</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let reviewerStatus of reviewersStatusperTask">
        <td class="col-md-1">
          <mat-slide-toggle color="blue" name="isApprover" [ngModel]="reviewerStatus.isApprover"></mat-slide-toggle>
        </td>
        <td class="col-md-5">
          {{reviewerStatus.reviewerName}}
        </td>
        <td class="col-md-5">
          <span alt="Task status" class="d-inline p-2 m-2 text-white" [ngStyle]="{'backgroundColor':getCSSColorStatus(reviewerStatus.approvalStatus)}">{{reviewerStatus.approvalStatus}}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
